import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconAirplane$1 = /*@__PURE__*/ proxyCustomElement(class WppIconAirplane extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-airplane", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.64222 1.58514C7.82996 1.58514 7.17149 2.24361 7.17149 3.05587L7.17254 3.12059L7.74317 7.90805L6.1981 7.95334L6.00388 7.42285L5.94936 7.29202L5.94624 7.28563C5.88138 7.15236 5.80287 7.03008 5.71301 6.92011C5.37892 6.51125 4.88793 6.27258 4.35816 6.27258L4.22501 6.27927L4.21625 6.28035C3.4563 6.37412 2.90665 6.98808 2.90665 7.72433L2.9069 8.25832L2.87766 8.2644C2.07527 8.43123 1.5 9.13842 1.5 9.95812C1.5 10.7777 2.0749 11.4849 2.87717 11.6524L2.9069 11.6586L2.90665 12.1917C2.90665 12.9936 3.55649 13.6435 4.35816 13.6435C5.09392 13.6435 5.75132 13.1839 6.00394 12.4928L6.19773 11.9627L7.75283 12.0081L7.17784 16.8118L7.17177 16.9184L7.17177 16.9253C7.17147 17.7552 7.82884 18.4148 8.64222 18.4148C9.42586 18.4148 10.1404 17.9665 10.4815 17.261L12.9477 12.1601L16.181 12.2548L16.1847 12.2548C17.4709 12.2551 18.5 11.2274 18.5 9.95812L18.4993 9.90189L18.4992 9.8999C18.4618 8.62312 17.4041 7.6251 16.1358 7.66235L12.9084 7.7568L10.4816 2.73875L10.407 2.59961L10.4036 2.59412C10.0197 1.9599 9.3584 1.58514 8.64222 1.58514ZM9.27699 9.11781L9.29193 9.24284L9.28827 9.11748L9.27699 9.11781ZM9.29193 9.24284L9.16608 9.24659L9.16741 9.25771L9.29193 9.24284ZM9.43274 9.36418L8.68364 3.09175C8.85473 3.10494 9.01004 3.19927 9.10028 3.346L9.1412 3.42269L11.9779 9.28969L16.1799 9.16671C16.6167 9.15388 16.9812 9.49726 16.9946 9.93386L16.995 9.96815C16.9946 10.3945 16.6419 10.7491 16.2048 10.7501L12.0172 10.6272L9.12654 16.6059C9.0422 16.7804 8.87116 16.8951 8.67978 16.9085L9.44287 10.5518L5.15678 10.4266L4.59041 11.9761C4.56104 12.0565 4.49288 12.1146 4.41169 12.1326L4.4125 10.4347L3.18424 10.179C3.08004 10.1572 3.00502 10.0651 3.00502 9.95812C3.00502 9.85153 3.07985 9.75956 3.18422 9.73786L4.4125 9.48215L4.41169 7.77816C4.46215 7.78707 4.53811 7.83286 4.57864 7.91299L4.60323 7.97272L5.15803 9.48948L9.43274 9.36418Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-airplane-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-airplane", "wpp-icon-airplane-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-airplane-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-airplane-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconAirplane$1);
      }
      break;
  } });
}

const WppIconAirplane = WppIconAirplane$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconAirplane, defineCustomElement };
